import { render, staticRenderFns } from "./default.vue?vue&type=template&id=a48fd1fa&"
import script from "./default.vue?vue&type=script&lang=ts&"
export * from "./default.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Header: require('/home/ec2-user/environment/xsearch-app/src/components/Header.vue').default,Menu: require('/home/ec2-user/environment/xsearch-app/src/components/Menu.vue').default,Footer: require('/home/ec2-user/environment/xsearch-app/src/components/Footer.vue').default,MyFolderModal: require('/home/ec2-user/environment/xsearch-app/src/components/MyFolderModal.vue').default,AriaLive: require('/home/ec2-user/environment/xsearch-app/src/components/AriaLive.vue').default,MyFolderMsgModal: require('/home/ec2-user/environment/xsearch-app/src/components/MyFolderMsgModal.vue').default})
